import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TournoisPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={100} />
      
      <div className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>
          
          <article className="prose prose-lg max-w-none">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Un été sportif à Cheyres : Retour sur le tournoi et les interclubs junior U12
            </h1>
            
            <p className="text-xl text-gray-700 leading-relaxed mb-8">
              Cet été, les courts de tennis de Cheyres ont été le théâtre de compétitions juniors animées, 
              avec un tournoi interne et une première participation aux interclubs U12. Deux événements 
              marquants qui ont permis aux jeunes joueurs de briller et d'exprimer leur passion pour le tennis.
            </p>

            {/* Photos des Interclubs U12 et Championnats romands */}
            <div className="grid md:grid-cols-2 gap-6 my-12">
              <img 
                src="https://customer-assets.emergentagent.com/job_cheyres-redesign/artifacts/ml2htluj_InterclubU12.jpg"
                alt="Interclubs junior U12"
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
              <img 
                src="https://customer-assets.emergentagent.com/job_cheyres-redesign/artifacts/16mxkkut_championnats%20romands2025.JPG"
                alt="Championnats romands 2025"
                className="w-full h-auto rounded-2xl shadow-2xl"
              />
            </div>

            <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6">
              Les vainqueurs du tournoi interne junior 2025
            </h2>

            <p className="text-gray-700 leading-relaxed mb-6">
              Le tournoi a été l'occasion pour les jeunes joueurs de l'école de tennis de se rencontrer, 
              d'échanger, et de progresser ensemble. La bonne humeur et le fair-play étaient au rendez-vous, 
              et tous les participants ont montré un véritable enthousiasme à participer, quel que soit le résultat.
            </p>

            <p className="text-gray-700 leading-relaxed mb-8">
              Après plusieurs semaines de compétitions intenses, les finalistes des différentes catégories 
              se sont affrontés pour décrocher la victoire.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Voici les champions 2025 du TC Cheyres-Châbles :
            </h3>

            {/* Image du tournoi */}
            <img 
              src="https://customer-assets.emergentagent.com/job_cheyres-redesign/artifacts/rowf7yvb_tournoi_interne2025.jpg"
              alt="Vainqueurs du tournoi interne junior 2025"
              className="w-full h-auto rounded-2xl shadow-2xl my-12"
            />

            <div className="bg-gradient-to-br from-green-50 to-emerald-50 p-8 rounded-2xl mt-12">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Félicitations à tous les participants !</h3>
              <p className="text-gray-700 leading-relaxed">
                Un grand bravo à tous les jeunes joueurs qui ont participé au tournoi interne et aux interclubs U12. 
                Votre engagement, votre fair-play et votre passion pour le tennis sont une source de fierté pour le club. 
                Continuez à progresser et à vous faire plaisir sur les courts !
              </p>
            </div>
          </article>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TournoisPage;